function renderSizeChart(){

  var headerTitle = $('#Avada-SC__Modal .Avada-Modal__ContainerWrapper > header');
  var headerClose = $('#Avada-SC__Modal .Avada-Modal__ContainerWrapper > button');
  
  var imagen = $('#avada-modal-content > div:nth-child(1)');
  var contentImage = $('#avada-modal-content > div:nth-child(2)');
  var infoSize = $('#avada-modal-content > div:nth-child(3)');
  var chartIn = $('#avada-modal-content > div:nth-child(4)');
  var chartCm = $('#avada-modal-content > div:nth-child(5)');

  console.log('Elementos seleccionados:', { headerClose, imagen, contentImage, infoSize, chartIn, chartCm });

  $(headerTitle).replaceWith(
    '<header class="container-title-close">'+
      '<div class="container-title-new"></div>' +
      '<div class="container-close-new"></div>' +
    '</header>'
  );
  
  $( "#avada-modal-content" ).append(
      '<div class="container-accordion">'+ 
          '<ul class="size-guide-chart-modal">' +
        
              '<li class="description-container description-container--htm">' +
                  '<h3>How to measure</h3>' +
                  '<div class="description-product__answer">' +
                      '<div class="description-product__answer-container">' +
                        '<div class="how-to-measure">' +
                          '<div class="container-image-size"></div>' +
                          '<div class="container-text-size"></div>' +
                        '</div>' +
                      '</div>' +
                  '</div>' +
              '</li>' +
  
              '<li class="description-container description-container--ss active_description">' +
                  '<h3>Standard sizing</h3>' +
                  '<div class="description-product__answer">' +
                      '<div class="description-product__answer-container">' +
          
                        '<div class="chart-table-measures">' +
                          
                          '<div class="chart-information"></div>' +
                          '<div class="chart-buttons">' +
                            '<p>View sizing in:</p>' +
                            '<div class="container-buttons">' +
                              '<button id="inches" class="active-button">inches</button>' +
                              '<button id="centimeters">cm</button>' +
                            '</div>' +
                          '</div>' +
                          '<div class="chart-tables">' +
            
                              '<div class="container-size-inches"></div>' +
                              '<div class="container-size-centimeters"></div>' +
                            
                          '</div>' +
                          
                        '</div>' +
                        
          
                      '</div>' +
                  '</div>' +
              '</li>' +
  
          '</ul>' +
      '</div>'
  );


  $('#Avada-SC__Modal .Avada-Modal__ContainerWrapper .container-title-new').append('<p>Size and Fit</p>');
  $('#Avada-SC__Modal .Avada-Modal__ContainerWrapper .container-close-new').append($(headerClose));
  
  $('#avada-modal-content .container-image-size').append($(imagen));
  $('#avada-modal-content .container-text-size').append($(contentImage));
  $('#avada-modal-content .chart-information').append($(infoSize));
  $('#avada-modal-content .container-size-inches').append($(chartIn));
  $('#avada-modal-content .container-size-centimeters').append($(chartCm));
  $('#avada-modal-content .chart-tables .container-size-centimeters').hide();

  $('#avada-modal-content .chart-tables table').removeAttr('style');
  $('#avada-modal-content .chart-tables td').removeAttr('style');

  $('#avada-modal-content .container-buttons #inches').on('click', function() {
      $('#avada-modal-content .chart-buttons .container-buttons button').removeClass("active-button");
      $('#avada-modal-content .chart-tables .container-size-centimeters').hide();
      $(this).addClass('active-button');
      $('#avada-modal-content .chart-tables .container-size-inches').show();
  });
  
  $('.container-buttons #centimeters').on('click', function() {
      $('#avada-modal-content .chart-buttons .container-buttons button').removeClass("active-button");
      $('#avada-modal-content .chart-tables .container-size-inches').hide();
      $(this).addClass('active-button');
      $('#avada-modal-content .chart-tables .container-size-centimeters').show();      
  });


  $('#avada-modal-content .size-guide-chart-modal > li > .description-product__answer').hide();
  $('#avada-modal-content .size-guide-chart-modal > li.active_description > .description-product__answer').show();
  
  $('#avada-modal-content .size-guide-chart-modal > li.description-container--htm > h3').click(function() {
    var $open_description = $(this).parents('li');
    if ($($open_description).hasClass("active_description")) {
      $($open_description).removeClass("active_description").find(".description-product__answer").slideUp();
    } else {
      $(".size-guide-chart-modal > li.description-container--htm.active_description .description-product__answer").slideUp();
      $(".size-guide-chart-modal > li.description-container--htm.active_description").removeClass("active_description");
      $($open_description).addClass("active_description").find(".description-product__answer").slideDown();
    }
    return false;
  });

};




function waitForElements(selectorArray, callback) {
  const interval = setInterval(() => {
    const allElementsLoaded = selectorArray.every(selector => $(selector).length > 0);
    if (allElementsLoaded) {
      clearInterval(interval);
      callback();
    }
  }, 100);
}

var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    var avadaElement = document.getElementById('avada-modal-content');
    if (avadaElement) {
      // console.log('🟢 V1');
      waitForElements([
        '#avada-modal-content > div:nth-child(1)',
        '#avada-modal-content > div:nth-child(2)',
        '#avada-modal-content > div:nth-child(3)',
        '#avada-modal-content > div:nth-child(4)',
        '#avada-modal-content > div:nth-child(5)'
      ], renderSizeChart);
      observer.disconnect();
    }
  });
});

var observerConfig = { childList: true, subtree: true };
observer.observe(document.body, observerConfig);